import { styled, ListItemButton } from '@mui/material'

export const StyledListItem = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'isItemSelected',
})(({ theme, isItemSelected }) => ({
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(0.5),
  cursor: 'pointer',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),

  borderLeft: isItemSelected
    ? `3px solid ${theme.palette.primary.main}`
    : '3px solid transparent',

  backgroundColor: isItemSelected ? theme.palette.action.selected : 'transparent',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  transition: 'background-color 0.15s, border-left 0.15s',
}))
